import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRetirement = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#9ae981",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.58472 15.0001C6.61966 14.1755 7.89541 13.7113 9.21822 13.6777H14.9808",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0496 6.00189C14.163 5.96223 14.2653 5.89596 14.3479 5.80863C14.4305 5.7213 14.4909 5.61546 14.5242 5.49996C14.5574 5.38446 14.5625 5.26268 14.539 5.14481C14.5156 5.02694 14.4642 4.91641 14.3892 4.82249C13.4178 3.60881 12.094 2.72607 10.6002 2.29575C9.10642 1.86544 7.51596 1.90872 6.04776 2.41963C4.57956 2.93055 3.30581 3.88398 2.40184 5.14868C1.49787 6.41339 1.00812 7.92719 1.00001 9.48172C0.9995 9.60196 1.02783 9.72057 1.08261 9.82761C1.13739 9.93464 1.21703 10.027 1.31486 10.0969C1.41269 10.1668 1.52585 10.2122 1.64486 10.2294C1.76387 10.2466 1.88526 10.2349 1.99885 10.1955L14.0496 6.00189Z",
			fill: "currentColor",
			fillOpacity: .3,
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.04788 2.4199L5.55383 1",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.02429 8.09888L9.9659 13.6778",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })
});
export default SvgRetirement;
